import React, { useMemo } from 'react';
import { track } from '../../services/analytics';
import { getExperiencesByCategory, getProductsByCategory } from '../../data/affiliateProducts';

const SpeciesAffiliates = ({ species }) => {
  const experiences = useMemo(() => getExperiencesByCategory(species.category, 3), [species.category]);
  const products = useMemo(() => getProductsByCategory(species.category, 4), [species.category]);

  const handleClick = (item, position) => {
    track('affiliate_click', {
      product: item.name,
      productId: item.id,
      category: item.category,
      program: item.program,
      position: `species_detail_${position}`,
      species: species.name,
    });
  };

  if ((!experiences || experiences.length === 0) && (!products || products.length === 0)) return null;

  return (
    <section className="px-12 py-24 max-w-7xl mx-auto space-y-24">
      {experiences && experiences.length > 0 && (
        <div>
          <h3 className="font-headline text-3xl text-on-surface mb-8">Related Experiences</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {experiences.map((item, i) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="sponsored noopener noreferrer"
                onClick={() => handleClick(item, `exp_${i}`)}
                className="group block"
              >
                <div className="aspect-[4/3] bg-surface-container-high rounded-xl overflow-hidden mb-4">
                  <img alt={item.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" src={item.image} loading="lazy" />
                </div>
                <h4 className="font-headline text-xl text-on-surface group-hover:text-primary transition-colors mb-1">{item.name}</h4>
                <p className="text-sm text-on-surface-variant font-body mb-2 line-clamp-2">{item.description}</p>
                <span className="text-primary font-label font-semibold">{item.price}</span>
              </a>
            ))}
          </div>
        </div>
      )}

      {products && products.length > 0 && (
        <div>
          <h3 className="font-headline text-3xl text-on-surface mb-8">Recommended Gear</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((item, i) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="sponsored noopener noreferrer"
                onClick={() => handleClick(item, `gear_${i}`)}
                className="group block"
              >
                <div className="aspect-square bg-surface-container-highest rounded-md mb-4 overflow-hidden">
                  <img alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src={item.image} loading="lazy" />
                </div>
                <h4 className="font-headline text-lg text-on-surface group-hover:text-primary transition-colors mb-1">{item.name}</h4>
                <p className="text-xs text-on-surface-variant font-body mb-2 line-clamp-2">{item.description}</p>
                <span className="font-body font-bold text-on-surface">{item.price}</span>
              </a>
            ))}
          </div>
        </div>
      )}

      <p className="text-slate-600 text-[10px] font-body">
        We may earn a small commission at no extra cost to you, helping keep this site running.
      </p>
    </section>
  );
};

export default SpeciesAffiliates;
